import { SettlementExtent } from '@mews-commander/data-access';
import { SelectField, SelectFieldProps } from '@mews-commander/form';
import { createOption } from '@mews-commander/ui';
import { lt, useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { WithServiceTimeClass } from '@mews-commander/types';
import { getTimeUnitPluralTextKeyByServiceTimeClass } from '@mews-commander/utils';

export const ExtentSelectField = ({
    serviceTimeClass,
    ...other
}: Omit<SelectFieldProps, 'options' | 'multiselect'> & Partial<WithServiceTimeClass>) => {
    const localizeText = useLocalizeText();

    const extentOptions = [
        createOption({
            value: SettlementExtent.TimeUnits,
            label: localizeText({
                textKey: serviceTimeClass
                    ? getTimeUnitPluralTextKeyByServiceTimeClass(serviceTimeClass)
                    : TextKey.SettlementExtentTimeUnits,
            }),
        }),
        createOption({
            value: SettlementExtent.Products,
            label: localizeText({ textKey: TextKey.SettlementExtentProducts }),
        }),
        createOption({
            value: SettlementExtent.AdditionalExpenses,
            label: localizeText({ textKey: TextKey.SettlementExtentAdditionalExpenses }),
        }),
    ];

    return <SelectField required label={lt('SettlementExtent')} {...other} options={extentOptions} multiselect />;
};
